import { Component, ViewChild } from "@angular/core";
import { NavController, Slides } from "ionic-angular";

@Component({
  selector: "walkthrough-page",
  templateUrl: "walkthrough.html"
})
export class WalkthroughPage {
  lastSlide = false;

  @ViewChild("slider") slider: Slides;

  constructor(public nav: NavController) {}

  skipIntro() {
    this.lastSlide = true;
    this.slider.slideTo(this.slider.length());
  }

  onSlideChanged() {
    this.lastSlide = this.slider.isEnd();
  }

  goToLogin() {
    this.nav.push("LoginPage");
  }

  goToSignup() {
    this.nav.push("SignupPage");
  }
}



// WEBPACK FOOTER //
// ./src/pages/walkthrough/walkthrough.ts